import { useLanguage } from '../contexts/LanguageContext';
// import { ArrowUpRight } from 'lucide-react';

export const PortfolioSection = () => {
  const { t } = useLanguage();

  // Projects data - uncomment and use when ready to display portfolio
  /*
  const projects = [
    {
      id: 1,
      title: 'Nordisk Arkitektur',
      category: language === 'no' ? 'Eiendom' : 'Real Estate',
      image: 'https://images.unsplash.com/photo-1622109908450-f9b87f8e2da9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwc2NhbmRpbmF2aWFuJTIwYXJjaGl0ZWN0dXJlJTIwYWJzdHJhY3QlMjBidWlsZGluZyUyMHdoaXRlJTIwZ3JleXxlbnwwfHx8fDE3NzM5NDgxMDl8MA&ixlib=rb-4.1.0&q=85',
      featured: true,
    },
    {
      id: 2,
      title: 'FinTech Dashboard',
      category: language === 'no' ? 'Finansteknologi' : 'Financial Technology',
      image: 'https://images.unsplash.com/photo-1739054730201-4b6463484e3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGZ1dHVyaXN0aWMlMjBkYXRhJTIwZGFzaGJvYXJkJTIwYmx1ZSUyMGRhcmslMjB1aSUyMHZpc3VhbGl6YXRpb258ZW58MHx8fHwxNzczOTQ4MTEwfDA&ixlib=rb-4.1.0&q=85',
      featured: false,
    },
    {
      id: 3,
      title: 'Studio Kontor',
      category: language === 'no' ? 'Interiørdesign' : 'Interior Design',
      image: 'https://images.unsplash.com/photo-1752170080668-fa46b5539cf4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzY2FuZGluYXZpYW4lMjBvZmZpY2UlMjBpbnRlcmlvciUyMG1pbmltYWxpc3QlMjB3b29kJTIwY29uY3JldGUlMjBwZW9wbGUlMjB3b3JraW5nfGVufDB8fHx8MTc3Mzk0ODExMXww&ixlib=rb-4.1.0&q=85',
      featured: false,
    },
    {
      id: 4,
      title: 'Digital Strategi',
      category: language === 'no' ? 'Markedsføring' : 'Marketing',
      image: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.0.3&q=85',
      featured: false,
    },
  ];
  */

  // Portfolio section is hidden for now - uncomment the grid below when ready
  return null;

  /* Uncomment this entire section when ready to show portfolio:
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="max-w-7xl mx-auto">
        <h2
          data-testid="portfolio-title"
          className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-16 fade-in-up"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('portfolioTitle')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {projects.map((project, index) => (
            <div
              key={project.id}
              data-testid={`portfolio-card-${project.id}`}
              className={`portfolio-card relative rounded-2xl overflow-hidden group cursor-pointer border border-white/5 hover:border-primary/30 transition-all duration-500 fade-in-up stagger-${index + 1} ${
                project.featured ? 'md:col-span-2 aspect-[2/1]' : 'aspect-[4/3]'
              }`}
            >
              <img
                src={project.image}
                alt={project.title}
                className="portfolio-image absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-sm text-primary font-medium mb-2">
                      {project.category}
                    </p>
                    <h3
                      className="text-2xl md:text-3xl font-semibold text-foreground"
                      style={{ fontFamily: 'Outfit, sans-serif' }}
                    >
                      {project.title}
                    </h3>
                  </div>
                  <button
                    data-testid={`view-project-${project.id}`}
                    className="w-12 h-12 rounded-full bg-primary/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary transition-all"
                  >
                    <ArrowUpRight className="w-5 h-5 text-foreground group-hover:text-primary-foreground transition-colors" />
                  </button>
                </div>
              </div>
              {project.featured && (
                <div className="absolute top-6 left-6">
                  <span className="px-4 py-2 rounded-full bg-primary/20 backdrop-blur-sm text-sm font-medium text-primary border border-primary/30">
                    {language === 'no' ? 'Utvalgt' : 'Featured'}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
  */
};
